"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/app/front/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/app/front/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/app/front/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WombatUser = void 0;

var eosjs_1 = require("eosjs");

var elliptic_1 = require("elliptic");

var eosjs_jssig_1 = require("eosjs/dist/eosjs-jssig");

var universal_authenticator_library_1 = require("universal-authenticator-library");

var UALWombatError_1 = require("./UALWombatError");

var KeyType = eosjs_1.Numeric.KeyType;
var ec = new elliptic_1.ec('secp256k1');

var WombatUser = /*#__PURE__*/function (_universal_authentica) {
  _inherits(WombatUser, _universal_authentica);

  var _super = _createSuper(WombatUser);

  function WombatUser(chain, scatter) {
    var _this;

    _classCallCheck(this, WombatUser);

    _this = _super.call(this);
    _this.chain = chain;
    _this.scatter = scatter;
    _this.keys = [];
    _this.accountName = '';
    var rpcEndpoint = _this.chain.rpcEndpoints[0];

    var rpcEndpointString = _this.buildRpcEndpoint(rpcEndpoint);

    _this.rpc = new eosjs_1.JsonRpc(rpcEndpointString);
    var network = {
      blockchain: 'eos',
      chainId: _this.chain.chainId,
      protocol: rpcEndpoint.protocol,
      host: rpcEndpoint.host,
      port: rpcEndpoint.port
    };
    var rpc = _this.rpc;
    _this.api = _this.scatter.eos(network, eosjs_1.Api, {
      rpc: rpc
    });
    return _this;
  }

  _createClass(WombatUser, [{
    key: "signTransaction",
    value: function signTransaction(transaction) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var completedTransaction;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.api.transact(transaction, config);

              case 3:
                completedTransaction = _context.sent;
                return _context.abrupt("return", this.returnEosjsTransaction((_a = config.broadcast) !== null && _a !== void 0 ? _a : true, completedTransaction));

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                throw new UALWombatError_1.UALWombatError(_context.t0.message || 'Unable to sign the given transaction', universal_authenticator_library_1.UALErrorType.Signing, _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));
    }
  }, {
    key: "verifyKeyOwnership",
    value: function verifyKeyOwnership(challenge) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  setTimeout(function () {
                    reject(new Error('verifyKeyOwnership failed'));
                  }, 1000);

                  _this2.authenticate(challenge, resolve);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "signArbitrary",
    value: function signArbitrary(publicKey, data, _) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.scatter.getArbitrarySignature(publicKey, data));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getAccountName",
    value: function getAccountName() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.accountName) {
                  _context4.next = 3;
                  break;
                }

                _context4.next = 3;
                return this.refreshIdentity();

              case 3:
                return _context4.abrupt("return", this.accountName);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getChainId",
    value: function getChainId() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.chain.chainId);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getKeys",
    value: function getKeys() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!this.keys || this.keys.length === 0)) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return this.refreshIdentity();

              case 3:
                return _context6.abrupt("return", this.keys);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "refreshIdentity",
    value: function refreshIdentity() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var rpcEndpoint, identity;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                rpcEndpoint = this.chain.rpcEndpoints[0];
                _context7.prev = 1;
                _context7.next = 4;
                return this.scatter.getIdentity({
                  accounts: [{
                    blockchain: 'eos',
                    host: rpcEndpoint.host,
                    port: rpcEndpoint.port,
                    chainId: this.chain.chainId
                  }]
                });

              case 4:
                identity = _context7.sent;
                this.keys = [identity.accounts[0].publicKey];
                this.accountName = identity.accounts[0].name;
                _context7.next = 12;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](1);
                throw new UALWombatError_1.UALWombatError('Unable load user\'s identity', universal_authenticator_library_1.UALErrorType.DataRequest, _context7.t0);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 9]]);
      }));
    }
  }, {
    key: "authenticate",
    value: function authenticate(challenge, resolve) {
      var _this3 = this;

      this.scatter.authenticate(challenge).then(function (signature) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          var publicKey, myKeys, resolvedValue, _iterator, _step, key;

          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  publicKey = this.getPublicKey(challenge, signature);
                  _context8.next = 3;
                  return this.getKeys();

                case 3:
                  myKeys = _context8.sent;
                  resolvedValue = false;
                  _iterator = _createForOfIteratorHelper(myKeys);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      key = _step.value;

                      if (key === publicKey) {
                        resolvedValue = true;
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  resolve(resolvedValue);

                case 8:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));
      });
    }
  }, {
    key: "getPublicKey",
    value: function getPublicKey(challenge, signature) {
      var ellipticSignature = eosjs_jssig_1.Signature.fromString(signature).toElliptic();
      var ellipticHashedStringAsBuffer = Buffer.from(ec.hash().update(challenge).digest(), 'hex');
      var ellipticRecoveredPublicKey = ec.recoverPubKey(ellipticHashedStringAsBuffer, ellipticSignature, ellipticSignature.recoveryParam, 'hex');
      var ellipticPublicKey = ec.keyFromPublic(ellipticRecoveredPublicKey);
      return eosjs_jssig_1.PublicKey.fromElliptic(ellipticPublicKey, KeyType.k1).toString();
    }
  }]);

  return WombatUser;
}(universal_authenticator_library_1.User);

exports.WombatUser = WombatUser;